import $ from 'jquery';
import { gsap } from 'gsap';
import "splitting/dist/splitting.css";
import Splitting from "splitting";

import { $Elements, Events } from '../global/constants';

// ---------- Init Base Animation ----------

export const initBaseAnimations = () => {

	// ---------- Animations ----------

	Splitting({
		target: $('.column-content .content > *:not(.button)')
	});


	// Menu Open / Close

	$('.header-wrapper .menu-toggle').on('click', function() {

		const self = $(this);
		const span = self.find('span');

		span.each(function() {
			$(this).toggleClass('active');
		})
	});
};



$Elements.document.on(Events.page.enter, () => initBaseAnimations());
